import * as socketio from "@/plugins/socketio";

export const socketListener = {
  methods: {
    socketListener(eventType, eventCallback) {
      if (eventType == "harmoniConnected") {
        socketio.harmoniListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "simfoniConnected") {
        socketio.simfoniListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "kanalaConnected") {
        socketio.kanalaListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "commDashConnected") {
        socketio.commDashListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "notifHrm") {
        socketio.harmoniListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "notifSim") {
        socketio.simfoniListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "notifKnl") {
        socketio.kanalaListener({
          type: eventType,
          callback: eventCallback,
        });
      } else if (eventType == "messageResponse") {
        socketio.commDashListener({
          type: eventType,
          callback: eventCallback,
        });
      }
    },
  },
};
